export const FORGOT_PASSWORD_VALIDATE = "FORGOT_PASSWORD_VALIDATE";
export const FORGOT_PASSWORD_VALIDATE_RESULT = "FORGOT_PASSWORD_VALIDATE_RESULT";